<div
    class="total-transactions-card trezo-card style-two mb-25 border-radius d-block shadow-none"
    [class.component-dark-theme]="themeService.isDark()"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="trezo-card-header d-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0 fw-normal text-white">
                Total B2CClient
            </h5>
        </div>
        <!--<div class="trezo-card-subtitle">
            <div class="trezo-card-header-menu position-relative">
                <button class="dot-menu style-two p-0 border-0 bg-transparent d-inline-block transition lh-1 text-white" (click)="toggleCardHeaderMenu()">
                    <i class="ri-more-2-fill"></i>
                </button>
                <ul class="dropdown-menu border-radius border-0 show" *ngIf="isCardHeaderOpen">
                    <li>
                        <button type="button" class="dropdown-item d-block w-100 position-relative transition">
                            This Day
                        </button>
                    </li>
                    <li>
                        <button type="button" class="dropdown-item d-block w-100 position-relative transition">
                            This Week
                        </button>
                    </li>
                    <li>
                        <button type="button" class="dropdown-item d-block w-100 position-relative transition">
                            This Month
                        </button>
                    </li>
                    <li>
                        <button type="button" class="dropdown-item d-block w-100 position-relative transition">
                            This Year
                        </button>
                    </li>
                </ul>
            </div>
        </div> -->
    </div>
    <div class="trezo-card-content bg-white">
        <div class="d-flex align-items-center justify-content-between">
            <h3 class="mb-0 fw-semibold">
                {{ dashboardCounter.totalB2CClient }}
            </h3>
            <div class="icon rounded-circle d-flex align-items-center justify-content-center">
                <img src="images/icons/transactions.svg" alt="transactions">
            </div>
        </div>
       <!-- <div class="info position-relative">
            <i class="material-symbols-outlined">
                trending_up
            </i>
            <span class="fw-semibold">
                +10%
            </span>
            from last month
        </div>  -->

    </div>
</div>